import { Box } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { LeafletMap } from '../LeafletMap/leaflet-map.comp'

import * as Styles from './map-card.styles'
import { MapCardProps } from './map-card.types'

export const MapCard = ({
  header,
  center,
  locations,
  mapOptions,
  maxHeight,
}: MapCardProps) => {
  const theme = useTheme()

  return (
    <Box
      padding={3}
      borderRadius="16px"
      backgroundColor="white"
      direction="column"
      width="100%"
      height="80vh"
      maxHeight={maxHeight}
      gap={2}
      boxShadow={theme.box_shadow.card}
    >
      {header && <Box width="100%">{header}</Box>}
      <Styles.MapWrapper>
        <LeafletMap
          center={center}
          locations={locations}
          {...(mapOptions ?? {})}
        />
      </Styles.MapWrapper>
    </Box>
  )
}
